import { AppAPiUrl } from "../../../configs/appData";
import Typography from "@mui/material/Typography";
import MaterialReactDataTable from "../../../components/layout/MaterialReactDataTable";
import AddSalesOrder from './AddSalesOrder';
import { useState } from "react";
import Swal from "sweetalert2";
import AxiosMain from "../../../components/layout/AxiosMain";

const SalesOrderDraft = (props: any) => {
  const { iComponetTranslate, setClose, updateCount } = props;

  const [selectedId, setSelectedId] = useState(null);

  const t = (name: string) => {
    const ifExist: any = iComponetTranslate.filter(
      (item: any) => item.label === name
    );
    if (ifExist.length > 0) {
      return ifExist[0].value
        ? ifExist[0].value
        : `No translate found (${ifExist[0].label})`;
    }
    return `No key found (${name})`;
  };

  const saleOrderRow = [
    {
      accessorFn: (row: any) => row?.created,
      header: t("CreateModified"),
    },
    {
      accessorFn: (row: any) => row?.count,
      header: t("Count"),
    },
    {
      accessorFn: (row: any) => row?.status,
      header: t("Status"),
    }
  ];

  const saleOrderSorting = [
    {
      descSort: "-CreateModified",
      ascSort: "CreateModified",
      id: t("CreateModified"),
    },
  ];

  const getSalesOrderDraft = (row: any) => {
    if(row.status === 'draft'){
      Swal.fire({
        text: "Do you want to Edit or Send this sales order draft",
        icon: 'warning',
        confirmButtonText: "Send",
        cancelButtonText: "Edit",
        showCancelButton: true,
        confirmButtonColor: '#103256',
        cancelButtonColor: '#d33',
      }).then(async(result) => {
        if(result.isConfirmed){
          try{
            const response = await AxiosMain.get(`${AppAPiUrl.SendSalesOrder.replace('<id>', row.id)}`);
            Swal.fire({
              title: 'success',
              icon: 'success',
              text: 'Sales Order Sent',
            });
          }
          catch(error){
            console.log(error);
          }
        }
        if(result.isDismissed){
          setSelectedId(row.id);
        }
      });
    }
  };
  if(selectedId){
    return(
      <AddSalesOrder iComponetTranslate={iComponetTranslate} setClose={setClose} selectedId={selectedId} updateCount={updateCount} />
    )
  }
  return (
    <div
      className="cm-sale-order-main"
      style={{ margin: "20px", minHeight: "60vh" }}
    >
      <Typography sx={{ marginBottom: 2 }} variant="h5">
        {t("SalesOrderDraft")}
      </Typography>
      <MaterialReactDataTable
        useFor={"Accounting Sale Orders Draft"}
        apiLink={AppAPiUrl.AccountingSalesorderDraft}
        tRow={saleOrderRow}
        clickFunc={getSalesOrderDraft}
        sortingData={saleOrderSorting}
      />
    </div>
  );
};

export default SalesOrderDraft;